import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { scheduleApi } from '../services/api';
import './Schedule.css';

const Schedule = () => {
  const [classes, setClasses] = useState([]);
  const [view, setView] = useState('week');
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        const response = await scheduleApi.getPublicSchedule();
        setClasses(response.data || []);
      } catch (err) {
        // Use mock data if API not available
        setClasses([
          { id: 1, name: 'Ballet Basics', time: '2025-12-23 10:00', duration: 60, instructor: 'Sarah Johnson', room: 'Studio A', spots: 3, capacity: 15 },
          { id: 2, name: 'Hip Hop', time: '2025-12-23 14:00', duration: 60, instructor: 'Mike Thompson', room: 'Studio B', spots: 8, capacity: 12 },
          { id: 3, name: 'Jazz Dance', time: '2025-12-23 16:00', duration: 90, instructor: 'Lisa Chen', room: 'Studio A', spots: 5, capacity: 15 },
          { id: 4, name: 'Contemporary', time: '2025-12-24 10:00', duration: 60, instructor: 'Sarah Johnson', room: 'Studio A', spots: 0, capacity: 15 },
          { id: 5, name: 'Pointe Work', time: '2025-12-24 14:00', duration: 60, instructor: 'Sarah Johnson', room: 'Studio B', spots: 4, capacity: 10 },
          { id: 6, name: 'Kids Ballet', time: '2025-12-25 09:00', duration: 45, instructor: 'Lisa Chen', room: 'Studio A', spots: 6, capacity: 12 },
          { id: 7, name: 'Ballet Basics', time: '2025-12-26 10:00', duration: 60, instructor: 'Sarah Johnson', room: 'Studio A', spots: 7, capacity: 15 },
        ]);
      } finally {
        setLoading(false);
      }
    };
    fetchSchedule();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  };

  const groupByDate = (classes) => {
    return classes.reduce((groups, cls) => {
      const date = cls.time.split(' ')[0];
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(cls);
      return groups;
    }, {});
  };

  const groupedClasses = groupByDate(classes);

  return (
    <div className="schedule-page">
      <header className="schedule-header">
        <div className="header-content">
          <div className="logo-section">
            <h1 className="logo">StudioAEye</h1>
            <p className="tagline">Dance Studio Management</p>
          </div>
          <div className="header-actions">
            <Link to="/login" className="btn btn-outline">Sign In</Link>
            <Link to="/register" className="btn btn-primary">Register</Link>
          </div>
        </div>
      </header>

      <main className="schedule-main">
        <div className="container">
          <div className="schedule-title">
            <h2>Class Schedule</h2>
            <p>Browse our upcoming classes and find the perfect one for you.</p>
          </div>

          <div className="view-controls">
            <button
              className={`view-btn ${view === 'day' ? 'active' : ''}`}
              onClick={() => setView('day')}
            >
              Day
            </button>
            <button
              className={`view-btn ${view === 'week' ? 'active' : ''}`}
              onClick={() => setView('week')}
            >
              Week
            </button>
            <button
              className={`view-btn ${view === 'month' ? 'active' : ''}`}
              onClick={() => setView('month')}
            >
              Month
            </button>
          </div>

          {loading ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>Loading schedule...</p>
            </div>
          ) : (
            <div className="schedule-content">
              {Object.entries(groupedClasses).map(([date, dayClasses]) => (
                <div key={date} className="day-group">
                  <h3 className="day-header">{formatDate(date + ' 00:00')}</h3>
                  <div className="classes-list">
                    {dayClasses.map((cls) => (
                      <div key={cls.id} className="class-card">
                        <div className="class-time">
                          <span className="time">{formatTime(cls.time)}</span>
                          <span className="duration">{cls.duration} min</span>
                        </div>
                        <div className="class-details">
                          <h4>{cls.name}</h4>
                          <p className="instructor">with {cls.instructor}</p>
                          <p className="location">{cls.room}</p>
                        </div>
                        <div className="class-booking">
                          {cls.spots > 0 ? (
                            <>
                              <span className="spots-available">{cls.spots} spots left</span>
                              <Link to="/login" className="btn btn-primary btn-sm">
                                Book Now
                              </Link>
                            </>
                          ) : (
                            <>
                              <span className="spots-full">Class Full</span>
                              <Link to="/login" className="btn btn-outline btn-sm">
                                Join Waitlist
                              </Link>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

      <footer className="schedule-footer">
        <div className="container">
          <p>© 2025 StudioAEye. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Schedule;